import * as asyncUtils from 'ui-permit/shared-components/utils/async';
import * as ACTIONS from '../constants/actions';

const getLotteries = asyncUtils.makeAsyncReducer(ACTIONS.GET_LOTTERIES);

export const lotteries = asyncUtils.mergeReducers(
    asyncUtils.asyncDefaults([]),
    ACTIONS.PREFIX,
    getLotteries,
);

export const selectors = {
    getLotteries: (state) => state.queuingLottery?.lotteries?.data || [],
    getError: (state) => state.queuingLottery?.lotteries?.error,
    isLoading: (state) => state.queuingLottery?.lotteries?.loading,
};
